<template>
	<div class="body">
		<div class="body-container" v-if="data">

			<div class="title-ctr">{{data.title}}</div>

			<div class="step-ctr">
				<div class="step-name">{{data.step}}</div>

				<div class="step-route" @click="clickRule(data.ruleRoute)">{{data.ruleRoute.title}}</div>
			</div>

			<el-table :data="data.list" border stripe>
				<el-table-column label="年份" align="center" prop="year" />
				<el-table-column label="平均用工人数（人）(基准用工人数)" align="center" prop="employee_num" />
			</el-table>
		</div>

		<div class="action-ctr">
			<el-button type="primary" icon="el-icon-right" size='medium' @click="clickNext()"
				class="next-btn">下一步</el-button>
		</div>

		<el-dialog title="原理介绍" :visible.sync="showIntroDialog" append-to-body v-if="showIntroDialog" align="center">

			<div class="rich-ctr">
				<div class="rich-value" v-html="introDialog.value"></div>
			</div>


			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseIntroDialog()">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import {
		getMatchTrend,
	} from "@/api/service"

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				params: {
					page: 1,
					pageSize: 20
				},
				data: null,
				showIntroDialog: false,
				introDialog: null,
				variableType: {
					File: 2,
					Rich: 3
				}
			}
		},
		created() {
			this.initPageData();
		},

		methods: {
			initPageData() {
				this.params['id'] = this.$route.query.id;
				this.requestData();
			},

			buildParams() {
				return this.params;
			},

			requestData() {
				getMatchTrend(this.buildParams()).then(res => {
					let realData = res.data;
					this.data = realData;
				});
			},

			clickNext() {
				let path = '/factor?id=' + this.params['id']
				this.$router.push(path);
			},

			clickRule(route) {
				if (route.type == this.variableType.File) {
					let path = route.path;
					window.open(path, '_blank')
				} else if (route.type == this.variableType.Rich) {
					this.showIntroDialog = true;
					this.introDialog = route;
				}
			},

			clickCloseIntroDialog() {
				this.showIntroDialog = false;
			}

		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "trend.scss";
</style>